import { Grid, Typography } from "@mui/material";
import ProjectsWidget from "./Cards/myProjectCard";
import LeaveWidget from "./Cards/CircularProgressLeave";
import TimeManagementWidget from "./Cards/TimeManagementWidget";
import LeavesWidget from "./Cards/latestLeavesWidget";
import CelebrationsWidget from "./Cards/CelebrationsWidget";
import TimeEntryChart from "./Cards/TimeEntryChart";
import { useSelector } from "react-redux";
import { RootStateType } from 'src/store/RootReducer';	


const DashboardView = () => {
  const appUser = useSelector((state: RootStateType) => state.appReducer.user);
  return (
    <div>
      <Grid
        container
        spacing={0}
        sx={{ mt: 2, mb: 2 }}
        justifyContent="space-between"
      >
        <Grid item xs={12}>
          <Typography
            sx={{
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            Dashboard
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        {/* Left Side Content */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ProjectsWidget />
            </Grid>
            <Grid item xs={12}>
              <TimeManagementWidget />
            </Grid>
            <Grid item xs={12}>
              <TimeEntryChart
               appUser={{
                EmployeeId: appUser?.EmployeeId || null, 
              }}
              selectedStatus={null} 
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Right Side Content */}
        <Grid item xs={12} md={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CelebrationsWidget />
            </Grid>
            <Grid item xs={12}>
              <LeaveWidget />
            </Grid>
            <Grid item xs={12}>
              <LeavesWidget />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default DashboardView;
